import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Dashboard } from "./components/Dashboard";
import { GeneralDashboard } from "./components/GeneralDashboard";
import { PlantHeadDashboard } from "./components/PlantHeadDashboard";
import { ExecutiveDashboard } from "./components/ExecutiveDashboard";
import RMDashboard from "./components/RMDashboard";
import { MaterialPlanningPage } from "./components/MaterialPlanningPage";
import { PurchaseDashboard } from "./components/PurchaseDashboard";
import { SalesDashboard } from "./components/SalesDashboard";
import FinishedGoodsDashboard from "./components/FinishedGoodsDashboard";
import AssemblyLineDashboard from "./components/AssemblyLineDashboard";
import StoreDashboard from "./components/StoreDashboard";
import StoreWorkOrderDetailPage from "./components/StoreWorkOrderDetailPage";
import FinishedGoodsInventoryReportPage from "./components/FinishedGoodsInventoryReportPage";
import { DashboardBlue } from "./components/DashboardBlue";
import { DashboardOrange } from "./components/DashboardOrange";
import { DashboardCoral } from "./components/DashboardCoral";
import { DashboardRedPink } from "./components/DashboardRedPink";
import { CustomThemeBuilder } from "./components/CustomThemeBuilder";
import { EndgoodForm } from './components/EndgoodInformationForm';
import { EndgoodListingPage } from './components/EndgoodListingPage';
import EndgoodViewPage from './components/EndgoodViewPage';
import { SupplierInformationForm } from "./components/SupplierInformationForm";
import { SupplierListingPage } from "./components/SupplierListingPage";
import { RawItemInformationForm } from './components/RawItemInformationForm';
import { RawItemListingPage } from './components/RawItemListingPage';
import { SalesOrderForm } from './components/SalesOrderForm';
import { SalesOrderListingPage } from './components/SalesOrderListingPage';
import { SalesOrderInformationForm } from './components/SalesOrderInformationForm';
import { CustomerInformationForm } from './components/CustomerInformationForm';
import { CustomerListingPage } from './components/CustomerListingPage';
import { PurchaseOrderForm } from './components/PurchaseOrderForm';
import { PurchaseOrderListingPage } from './components/PurchaseOrderListingPage';
import { PurchaseOrderPdfView } from './components/PurchaseOrderPdfView';
import { ChallanListingPage } from './components/ChallanListingPage';
import { ChallanForm } from './components/ChallanForm';
import { ChallanViewPage } from './components/ChallanViewPage';
import { ProductionPlanningPage } from './components/ProductionPlanningPage';
import { WIPTrackingPage } from './components/WIPTrackingPage';
import TrackingPage from './components/TrackingPage';
import { BOMPage } from './components/BOMPage';
import { BOMListingPage } from './components/BOMlistingPage';
import GRNForm from './components/GRNForm';
import GRNListingPage from './components/GRNListingPage';
import { GRNViewPage } from './components/GRNViewPage';
import { GrnEditRoute } from './components/GrnEditRoute';
import { ManualGRNEntry } from './components/ManualGRNEntry';
import { AccessDocPage } from './components/AccessDocPage';
import { UserProfilePage } from './components/UserProfilePage';
import { UserListingPage } from './components/UserListingPage';
import { UserForm } from './components/UserForm';
import { RoleListingPage } from './components/RoleListingPage';
import { WorkerListingPage } from './components/WorkerListingPage';
import { WorkerInformationForm } from './components/WorkerInformationForm';
import { RoleForm } from './components/RoleForm';
import { LoginDemo } from './components/LoginDemo';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ProtectedRouteNoLayout } from './components/ProtectedRouteNoLayout';

import { WorkOrderForm } from './components/WorkOrderPage';
import { WorkOrderListingPage } from './components/WorkOrderListingPage';
import { JobCardView } from './components/JobCardView';

import WorkOrderOperationRegistration from './components/WorkOrderOperationRegistration';
import PackingEntriesPage from './components/PackingEntriesPage';
import PackingEntryForm from './components/PackingEntryForm';
import PackingEntryViewPage from './components/PackingEntryViewPage';
import PackingEntryBoxesEditPage from './components/PackingEntryBoxesEditPage';
import BoxMasterPage from './components/BoxMasterPage';
import BoxMasterEndgoodsPage from './components/BoxMasterEndgoodsPage';
import { StoreMasterPage } from './components/StoreMasterPage';
import { StoreInventoryPage } from './components/StoreInventoryPage';
import { StoreItemIssueHistoryPage } from './components/StoreItemIssueHistoryPage';
import { StoreForm } from './components/StoreForm';
import { StoreViewPage } from './components/StoreViewPage';
import InvoiceListingPage from './components/InvoiceListingPage';
import InvoiceViewPage from './components/InvoiceViewPage';
import InvoiceEwayBillPage from './components/InvoiceEwayBillPage';
import ChargeMasterListingPage from './components/ChargeMasterListingPage';
import InvoiceCreatePage from './components/InvoiceCreatePage';
import InvoiceEditPage from './components/InvoiceEditPage';
import EndgoodCostPage from './components/EndgoodCostPage';
import InvoiceSalesReportPage from './components/InvoiceSalesReportPage';
import CreditDebitReportPage from './components/CreditDebitReportPage';
import HsnReportPage from './components/HsnReportPage';
import { CreditDebitNoteListingPage } from './components/CreditDebitNoteListingPage';
import { CreditDebitNoteViewPage } from './components/CreditDebitNoteViewPage';
import { CreditDebitNoteFormPage } from './components/CreditDebitNoteFormPage';
import { ManualCreditDebitNoteFormPage } from './components/ManualCreditDebitNoteFormPage';
import { Layout } from './components/Layout';
import { Toaster } from './components/ui/sonner';
import { BranchProvider } from "./contexts/BranchContext";
import { AuthProvider } from "./contexts/AuthContext";
import { PhysicalMachineListingPage } from './components/PhysicalMachineListingPage';
import { PhysicalMachineInformationForm } from './components/PhysicalMachineInformationForm';
import { HSNListingPage } from './components/HSNListingPage';
import { HSNInformationForm } from './components/HSNInformationForm';
import ReportsPage from './components/ReportsPage';
import RMInventoryReportPage from './components/RMInventoryReportPage';
import MaterialIssueReportPage from './components/MaterialIssueReportPage';
import SupplierPerformanceReportPage from './components/SupplierPerformanceReportPage';
import SupplierPerformanceDetailPage from './components/SupplierPerformanceDetailPage';
import SupplierBalanceReportPage from './components/SupplierBalanceReportPage';
import MISReportPage from './components/MISReportPage';
import ProductionReportPage from './components/ProductionReportPage';
import ScrapReportPage from './components/ScrapReportPage';
import WorkerPerformancePage from './components/WorkerPerformancePage';
import SalesOrderPerformanceReportPage from './components/SalesOrderPerformanceReportPage';
import SalesOrderPerformanceDetailPage from './components/SalesOrderPerformanceDetailPage';

function App() {
  return (
    <AuthProvider>
      <BranchProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<LoginDemo />} />
            
            {/* All other routes use the Layout with sidebar */}
            {/* Dashboard Routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <GeneralDashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/general" element={
              <ProtectedRoute>
                <GeneralDashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/plant-head" element={
              <ProtectedRoute>
                <PlantHeadDashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/executive" element={
              <ProtectedRoute>
                <ExecutiveDashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/rm-inventory" element={
              <ProtectedRoute>
                <RMDashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/material-planning" element={
              <ProtectedRoute>
                <MaterialPlanningPage />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/purchase-dashboard" element={
              <ProtectedRoute>
                <PurchaseDashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/sales-dashboard" element={
              <ProtectedRoute requiredPermissions={{ route: '/dashboard/sales-dashboard', actions: ['view'] }}>
                <SalesDashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/finished-goods" element={
              <ProtectedRoute>
                <FinishedGoodsDashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/assembly-line" element={
              <ProtectedRoute>
                <AssemblyLineDashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/store" element={
              <ProtectedRoute>
                <StoreDashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/store/:workOrderId" element={
              <ProtectedRoute>
                <StoreWorkOrderDetailPage />
              </ProtectedRoute>
            } />
            
            {/* BOM Routes */}
            <Route path="/bom" element={
              <ProtectedRoute requiredPermissions={{ route: '/bom', actions: ['view'] }}>
                <BOMListingPage />
              </ProtectedRoute>
            } />
            <Route path="/bom/new" element={
              <ProtectedRoute requiredPermissions={{ route: '/bom', actions: ['create'] }}>
                <BOMPage />
              </ProtectedRoute>
            } />
            <Route path="/bom/:mode/:bomId" element={
              <ProtectedRoute requiredPermissions={{ route: '/bom', actions: ['view'] }}>
                <BOMPage />
              </ProtectedRoute>
            } />
            
            {/* GRN Routes */}
            <Route path="/grn" element={
              <ProtectedRoute requiredPermissions={{ route: '/grn', actions: ['view'] }}>
                <GRNListingPage />
              </ProtectedRoute>
            } />
            <Route path="/grn/new" element={
              <ProtectedRoute requiredPermissions={{ route: '/grn', actions: ['create'] }}>
                <GRNForm />
              </ProtectedRoute>
            } />
            <Route path="/grn/view/:id" element={
              <ProtectedRoute requiredPermissions={{ route: '/grn', actions: ['view'] }}>
                <GRNViewPage />
              </ProtectedRoute>
            } />
            <Route path="/grn/edit/:id" element={<GrnEditRoute />} />
            <Route path="/grn/:grnId/access-doc" element={
              <ProtectedRoute requiredPermissions={{ route: '/grn', actions: ['view'] }}>
                <AccessDocPage />
              </ProtectedRoute>
            } />
            
            {/* Raw Material Receipt Routes */}
            <Route path="/raw-material-receipt" element={
              <ProtectedRoute requiredPermissions={{ route: '/grn', actions: ['create'] }}>
                <ManualGRNEntry />
              </ProtectedRoute>
            } />
            
            {/* Raw Item Routes */}
            <Route path="/raw-items" element={
              <ProtectedRoute requiredPermissions={{ route: '/raw-items', actions: ['view'] }}>
                <RawItemListingPage />
              </ProtectedRoute>
            } />
            <Route path="/raw-items/new" element={
              <ProtectedRoute requiredPermissions={{ route: '/raw-items', actions: ['create'] }}>
                <RawItemInformationForm />
              </ProtectedRoute>
            } />
            <Route path="/raw-items/:id" element={
              <ProtectedRoute requiredPermissions={{ route: '/raw-items', actions: ['view', 'edit'] }}>
                <RawItemInformationForm />
              </ProtectedRoute>
            } />
            
            {/* Endgood Routes */}
            <Route path="/endgoods" element={
              <ProtectedRoute requiredPermissions={{ route: '/endgoods', actions: ['view'] }}>
                <EndgoodListingPage />
              </ProtectedRoute>
            } />
            <Route path="/endgoods/new" element={
              <ProtectedRoute requiredPermissions={{ route: '/endgoods', actions: ['create'] }}>
                <EndgoodForm />
              </ProtectedRoute>
            } />
            <Route path="/endgoods/:id/edit" element={
              <ProtectedRoute requiredPermissions={{ route: '/endgoods', actions: ['edit'] }}>
                <EndgoodForm />
              </ProtectedRoute>
            } />
            <Route path="/endgoods/:id/view" element={
              <ProtectedRoute requiredPermissions={{ route: '/endgoods', actions: ['view'] }}>
                <EndgoodViewPage />
              </ProtectedRoute>
            } />
            <Route path="/endgoods/:id" element={
              <ProtectedRoute requiredPermissions={{ route: '/endgoods', actions: ['view', 'edit'] }}>
                <EndgoodForm />
              </ProtectedRoute>
            } />
            
            {/* Customer Routes */}
            <Route path="/customers" element={
              <ProtectedRoute requiredPermissions={{ route: '/customers', actions: ['view'] }}>
                <CustomerListingPage />
              </ProtectedRoute>
            } />
            <Route path="/customers/new" element={
              <ProtectedRoute requiredPermissions={{ route: '/customers', actions: ['create'] }}>
                <CustomerInformationForm />
              </ProtectedRoute>
            } />
            <Route path="/customers/:id/edit" element={
              <ProtectedRoute requiredPermissions={{ route: '/customers', actions: ['edit'] }}>
                <CustomerInformationForm />
              </ProtectedRoute>
            } />
            <Route path="/customers/:id/view" element={
              <ProtectedRoute requiredPermissions={{ route: '/customers', actions: ['view'] }}>
                <CustomerInformationForm />
              </ProtectedRoute>
            } />
            
            {/* Supplier Routes */}
            <Route path="/suppliers" element={
              <ProtectedRoute requiredPermissions={{ route: '/suppliers', actions: ['view'] }}>
                <SupplierListingPage />
              </ProtectedRoute>
            } />
            <Route path="/suppliers/new" element={
              <ProtectedRoute requiredPermissions={{ route: '/suppliers', actions: ['create'] }}>
                <SupplierInformationForm />
              </ProtectedRoute>
            } />
            <Route path="/suppliers/:id" element={
              <ProtectedRoute requiredPermissions={{ route: '/suppliers', actions: ['view', 'edit'] }}>
                <SupplierInformationForm />
              </ProtectedRoute>
            } />
            
            {/* Purchase Order Routes */}
            <Route path="/purchase-orders" element={
              <ProtectedRoute requiredPermissions={{ route: '/purchase-orders', actions: ['view'] }}>
                <PurchaseOrderListingPage />
              </ProtectedRoute>
            } />
            <Route path="/purchase-orders/new" element={
              <ProtectedRoute requiredPermissions={{ route: '/purchase-orders', actions: ['create'] }}>
                <PurchaseOrderForm />
              </ProtectedRoute>
            } />
            <Route path="/purchase-orders/:id/edit" element={
              <ProtectedRoute requiredPermissions={{ route: '/purchase-orders', actions: ['edit'] }}>
                <PurchaseOrderForm />
              </ProtectedRoute>
            } />
            <Route path="/purchase-orders/:id/view" element={
              <ProtectedRoute requiredPermissions={{ route: '/purchase-orders', actions: ['view'] }}>
                <PurchaseOrderForm />
              </ProtectedRoute>
            } />
            <Route path="/purchase-orders/:id/pdf" element={
              <ProtectedRouteNoLayout requiredPermissions={{ route: '/purchase-orders', actions: ['view'] }}>
                <PurchaseOrderPdfView />
              </ProtectedRouteNoLayout>
            } />
            <Route path="/purchase-orders/:id" element={
              <ProtectedRoute requiredPermissions={{ route: '/purchase-orders', actions: ['view', 'edit'] }}>
                <PurchaseOrderForm />
              </ProtectedRoute>
            } />
            
            {/* Challan Routes */}
            <Route path="/challans" element={
              <ProtectedRoute requiredPermissions={{ route: '/challans', actions: ['view'] }}>
                <ChallanListingPage />
              </ProtectedRoute>
            } />
            <Route path="/challans/new" element={
              <ProtectedRoute requiredPermissions={{ route: '/challans', actions: ['create'] }}>
                <ChallanForm />
              </ProtectedRoute>
            } />
            <Route path="/challans/:id/edit" element={
              <ProtectedRoute requiredPermissions={{ route: '/challans', actions: ['edit'] }}>
                <ChallanForm />
              </ProtectedRoute>
            } />
            <Route path="/challans/:id/view" element={
              <ProtectedRoute requiredPermissions={{ route: '/challans', actions: ['view'] }}>
                <ChallanViewPage />
              </ProtectedRoute>
            } />
            
            {/* Sales Order Routes */}
            <Route path="/sales-orders" element={
              <ProtectedRoute requiredPermissions={{ route: '/sales-orders', actions: ['view'] }}>
                <SalesOrderListingPage />
              </ProtectedRoute>
            } />
            <Route path="/sales-orders/new" element={
              <ProtectedRoute requiredPermissions={{ route: '/sales-orders', actions: ['create'] }}>
                <SalesOrderForm />
              </ProtectedRoute>
            } />
            <Route path="/sales-orders/:id/edit" element={
              <ProtectedRoute requiredPermissions={{ route: '/sales-orders', actions: ['edit'] }}>
                <SalesOrderForm />
              </ProtectedRoute>
            } />
            <Route path="/sales-orders/:id/view" element={
              <ProtectedRoute requiredPermissions={{ route: '/sales-orders', actions: ['view'] }}>
                <SalesOrderForm />
              </ProtectedRoute>
            } />
            <Route path="/sales-orders/:id" element={
              <ProtectedRoute requiredPermissions={{ route: '/sales-orders', actions: ['view', 'edit'] }}>
                <SalesOrderForm />
              </ProtectedRoute>
            } />
            <Route path="/sales-orders/form" element={
              <ProtectedRoute requiredPermissions={{ route: '/sales-orders', actions: ['create'] }}>
                <SalesOrderForm />
              </ProtectedRoute>
            } />
            <Route path="/sales-orders/listing" element={
              <ProtectedRoute requiredPermissions={{ route: '/sales-orders', actions: ['view'] }}>
                <SalesOrderListingPage />
              </ProtectedRoute>
            } />
            <Route path="/sales-orders/information" element={
              <ProtectedRoute requiredPermissions={{ route: '/sales-orders', actions: ['view', 'edit'] }}>
                <SalesOrderInformationForm />
              </ProtectedRoute>
            } />

            
            {/* Production Routes */}
            <Route path="/production-planning" element={
              <ProtectedRoute requiredPermissions={{ route: '/production-planning', actions: ['view'] }}>
                <ProductionPlanningPage />
              </ProtectedRoute>
            } />
            <Route path="/wip-tracking" element={
              <ProtectedRoute requiredPermissions={{ route: '/wip-tracking', actions: ['view'] }}>
                <WIPTrackingPage />
              </ProtectedRoute>
            } />
            <Route path="/tracking" element={
              <ProtectedRoute requiredPermissions={{ route: '/tracking', actions: ['view'] }}>
                <TrackingPage />
              </ProtectedRoute>
            } />
            
            {/* User Profile */}
            <Route path="/profile" element={
              <ProtectedRoute>
                <UserProfilePage />
              </ProtectedRoute>
            } />
            
            {/* User Management Routes */}
            <Route path="/users" element={
              <ProtectedRoute requiredPermissions={{ route: '/users', actions: ['view'] }}>
                <UserListingPage />
              </ProtectedRoute>
            } />
            <Route path="/users/new" element={
              <ProtectedRoute requiredPermissions={{ route: '/users', actions: ['create'] }}>
                <UserForm />
              </ProtectedRoute>
            } />
            <Route path="/users/:id" element={
              <ProtectedRoute requiredPermissions={{ route: '/users', actions: ['view', 'edit'] }}>
                <UserForm />
              </ProtectedRoute>
            } />
            <Route path="/users/:id/edit" element={
              <ProtectedRoute requiredPermissions={{ route: '/users', actions: ['edit'] }}>
                <UserForm />
              </ProtectedRoute>
            } />
            <Route path="/users/:id/view" element={
              <ProtectedRoute requiredPermissions={{ route: '/users', actions: ['view'] }}>
                <UserForm />
              </ProtectedRoute>
            } />

            {/* Worker Master Routes */}
            <Route path="/workers" element={
              <ProtectedRoute requiredPermissions={{ route: '/workers', actions: ['view'] }}>
                <WorkerListingPage />
              </ProtectedRoute>
            } />
            <Route path="/workers/new" element={
              <ProtectedRoute requiredPermissions={{ route: '/workers', actions: ['create'] }}>
                <WorkerInformationForm />
              </ProtectedRoute>
            } />
            <Route path="/workers/:id/edit" element={
              <ProtectedRoute requiredPermissions={{ route: '/workers', actions: ['edit'] }}>
                <WorkerInformationForm />
              </ProtectedRoute>
            } />
            <Route path="/workers/:id/view" element={
              <ProtectedRoute requiredPermissions={{ route: '/workers', actions: ['view'] }}>
                <WorkerInformationForm />
              </ProtectedRoute>
            } />
            
            {/* Role Management Routes */}
            <Route path="/roles" element={
              <ProtectedRoute requiredPermissions={{ route: '/roles', actions: ['view'] }}>
                <RoleListingPage />
              </ProtectedRoute>
            } />
            <Route path="/roles/new" element={
              <ProtectedRoute requiredPermissions={{ route: '/roles', actions: ['create'] }}>
                <RoleForm />
              </ProtectedRoute>
            } />
            <Route path="/roles/:id/view" element={
              <ProtectedRoute requiredPermissions={{ route: '/roles', actions: ['view'] }}>
                <RoleForm />
              </ProtectedRoute>
            } />
            <Route path="/roles/:id/edit" element={
              <ProtectedRoute requiredPermissions={{ route: '/roles', actions: ['edit'] }}>
                <RoleForm />
              </ProtectedRoute>
            } />
            <Route path="/work-orders" element={
              <ProtectedRoute requiredPermissions={{ route: '/work-orders', actions: ['view'] }}>
                <WorkOrderListingPage />
              </ProtectedRoute>
            } />
            <Route path="/work-orders/new" element={
              <ProtectedRoute requiredPermissions={{ route: '/work-orders', actions: ['create'] }}>
                <WorkOrderForm />
              </ProtectedRoute>
            } />
            <Route path="/work-orders/:id/edit" element={
              <ProtectedRoute requiredPermissions={{ route: '/work-orders', actions: ['edit'] }}>
                <WorkOrderForm />
              </ProtectedRoute>
            } />
            <Route path="/work-orders/:id/view" element={
              <ProtectedRoute requiredPermissions={{ route: '/work-orders', actions: ['view'] }}>
                <WorkOrderForm />
              </ProtectedRoute>
            } />
            <Route path="/work-orders/:id/job-card" element={
              <ProtectedRoute requiredPermissions={{ route: '/work-orders', actions: ['view'] }}>
                <JobCardView />
              </ProtectedRoute>
            } />
            <Route path="/work-orders/:id" element={
              <ProtectedRoute requiredPermissions={{ route: '/work-orders', actions: ['view', 'edit'] }}>
                <WorkOrderForm />
              </ProtectedRoute>
            } />
            <Route path="/work-order-registration" element={
              <ProtectedRoute requiredPermissions={{ route: '/work-order-registration', actions: ['view'] }}>
                <WorkOrderOperationRegistration />
              </ProtectedRoute>
            } />
            
            {/* Packing Entries */}
            <Route path="/packing-entries" element={
              <ProtectedRoute requiredPermissions={{ route: '/packing-entries', actions: ['view'] }}>
                <PackingEntriesPage />
              </ProtectedRoute>
            } />
            <Route path="/packing-entries/new" element={
              <ProtectedRoute requiredPermissions={{ route: '/packing-entries', actions: ['create'] }}>
                <PackingEntryForm />
              </ProtectedRoute>
            } />
            <Route path="/packing-entries/:id" element={
              <ProtectedRoute requiredPermissions={{ route: '/packing-entries', actions: ['view'] }}>
                <PackingEntryViewPage />
              </ProtectedRoute>
            } />
            <Route path="/packing-entries/batch/:batchId" element={
              <ProtectedRoute requiredPermissions={{ route: '/packing-entries', actions: ['view'] }}>
                <PackingEntryViewPage />
              </ProtectedRoute>
            } />
            <Route path="/packing-entries/:id/edit" element={
              <ProtectedRoute requiredPermissions={{ route: '/packing-entries', actions: ['edit'] }}>
                <PackingEntryForm />
              </ProtectedRoute>
            } />
            <Route path="/packing-entries/batch/:batchId/edit" element={
              <ProtectedRoute requiredPermissions={{ route: '/packing-entries', actions: ['edit'] }}>
                <PackingEntryForm />
              </ProtectedRoute>
            } />
            <Route path="/packing-entries/batch/:batchId/boxes-edit" element={
              <ProtectedRoute requiredPermissions={{ route: '/packing-entries', actions: ['edit'] }}>
                <PackingEntryBoxesEditPage />
              </ProtectedRoute>
            } />
            <Route path="/packing-entries/box-master/endgoods/:boxTypeId" element={
              <ProtectedRoute requiredPermissions={{ route: '/packing-entries', actions: ['view'] }}>
                <BoxMasterEndgoodsPage />
              </ProtectedRoute>
            } />
            <Route path="/packing-entries/box-master/endgoods" element={<Navigate to="/packing-entries/box-master" replace />} />
            <Route path="/packing-entries/box-master" element={
              <ProtectedRoute requiredPermissions={{ route: '/packing-entries', actions: ['view'] }}>
                <BoxMasterPage />
              </ProtectedRoute>
            } />
            
            {/* Store Management Routes */}
            <Route path="/stores" element={
              <ProtectedRoute requiredPermissions={{ route: '/stores', actions: ['view'] }}>
                <StoreMasterPage />
              </ProtectedRoute>
            } />
            <Route path="/stores/create" element={
              <ProtectedRoute requiredPermissions={{ route: '/stores', actions: ['create'] }}>
                <StoreForm />
              </ProtectedRoute>
            } />
            <Route path="/stores/edit/:id" element={
              <ProtectedRoute requiredPermissions={{ route: '/stores', actions: ['edit'] }}>
                <StoreForm />
              </ProtectedRoute>
            } />
            <Route path="/stores/view/:id" element={
              <ProtectedRoute requiredPermissions={{ route: '/stores', actions: ['view'] }}>
                <StoreViewPage />
              </ProtectedRoute>
            } />
            <Route path="/store-inventory" element={
              <ProtectedRoute requiredPermissions={{ route: '/store-inventory', actions: ['view'] }}>
                <StoreInventoryPage />
              </ProtectedRoute>
            } />
            <Route path="/store-inventory/:storeId/item/:itemId/history" element={
              <ProtectedRoute requiredPermissions={{ route: '/store-inventory', actions: ['view'] }}>
                <StoreItemIssueHistoryPage />
              </ProtectedRoute>
            } />

            {/* Physical Machine Master Routes */}
            <Route path="/physical-machines" element={
              <ProtectedRoute requiredPermissions={{ route: '/physical-machines', actions: ['view'] }}>
                <PhysicalMachineListingPage />
              </ProtectedRoute>
            } />
            <Route path="/physical-machines/new" element={
              <ProtectedRoute requiredPermissions={{ route: '/physical-machines', actions: ['create'] }}>
                <PhysicalMachineInformationForm />
              </ProtectedRoute>
            } />
            <Route path="/physical-machines/:id/edit" element={
              <ProtectedRoute requiredPermissions={{ route: '/physical-machines', actions: ['edit'] }}>
                <PhysicalMachineInformationForm />
              </ProtectedRoute>
            } />
            <Route path="/physical-machines/:id/view" element={
              <ProtectedRoute requiredPermissions={{ route: '/physical-machines', actions: ['view'] }}>
                <PhysicalMachineInformationForm />
              </ProtectedRoute>
            } />

            {/* HSN Master Routes */}
            <Route path="/hsn" element={
              <ProtectedRoute requiredPermissions={{ route: '/hsn', actions: ['view'] }}>
                <HSNListingPage />
              </ProtectedRoute>
            } />
            <Route path="/hsn/new" element={
              <ProtectedRoute requiredPermissions={{ route: '/hsn', actions: ['create'] }}>
                <HSNInformationForm />
              </ProtectedRoute>
            } />
            <Route path="/hsn/:id/edit" element={
              <ProtectedRoute requiredPermissions={{ route: '/hsn', actions: ['edit'] }}>
                <HSNInformationForm />
              </ProtectedRoute>
            } />
            <Route path="/hsn/:id/view" element={
              <ProtectedRoute requiredPermissions={{ route: '/hsn', actions: ['view'] }}>
                <HSNInformationForm />
              </ProtectedRoute>
            } />
                                                  {/* Packing Entries */}
             <Route path="/packing-entries" element={
               <ProtectedRoute requiredPermissions={{ route: '/packing-entries', actions: ['view'] }}>
                 <PackingEntriesPage />
               </ProtectedRoute>
             } />
             <Route path="/packing-entries/new" element={
               <ProtectedRoute requiredPermissions={{ route: '/packing-entries', actions: ['create'] }}>
                 <PackingEntryForm />
               </ProtectedRoute>
             } />
             <Route path="/packing-entries/:id" element={
               <ProtectedRoute requiredPermissions={{ route: '/packing-entries', actions: ['view'] }}>
                 <PackingEntryViewPage />
               </ProtectedRoute>
             } />
             <Route path="/packing-entries/:id/edit" element={
               <ProtectedRoute requiredPermissions={{ route: '/packing-entries', actions: ['edit'] }}>
                 <PackingEntryForm />
               </ProtectedRoute>
             } />
             <Route path="/packing-entries/batch/:batchId/edit" element={
               <ProtectedRoute requiredPermissions={{ route: '/packing-entries', actions: ['edit'] }}>
                 <PackingEntryForm />
               </ProtectedRoute>
             } />
             
             {/* Invoice Routes */}
             <Route path="/invoices" element={
               <ProtectedRoute requiredPermissions={{ route: '/invoices', actions: ['view'] }}>
                 <InvoiceListingPage />
               </ProtectedRoute>
             } />
             <Route path="/invoices/new" element={
               <ProtectedRoute requiredPermissions={{ route: '/invoices', actions: ['create'] }}>
                 <InvoiceCreatePage />
               </ProtectedRoute>
             } />
            <Route path="/invoices/:id/view" element={
              <ProtectedRoute requiredPermissions={{ route: '/invoices', actions: ['view'] }}>
                <InvoiceViewPage />
              </ProtectedRoute>
            } />
            <Route path="/invoices/:id/eway-bill" element={
              <ProtectedRoute requiredPermissions={{ route: '/invoices', actions: ['view'] }}>
                <InvoiceEwayBillPage />
              </ProtectedRoute>
            } />
             <Route path="/invoices/:id/edit" element={
               <ProtectedRoute requiredPermissions={{ route: '/invoices', actions: ['edit'] }}>
                 <InvoiceEditPage />
               </ProtectedRoute>
             } />
             <Route path="/invoices/endgood-cost" element={
               <ProtectedRoute requiredPermissions={{ route: '/invoices', actions: ['view'] }}>
                 <EndgoodCostPage />
               </ProtectedRoute>
             } />
             <Route path="/invoices/sales-report" element={
               <ProtectedRoute requiredPermissions={{ route: '/invoices', actions: ['view'] }}>
                 <InvoiceSalesReportPage />
               </ProtectedRoute>
             } />
             <Route path="/invoices/credit-debit-report" element={
               <ProtectedRoute requiredPermissions={{ route: '/invoices', actions: ['view'] }}>
                 <CreditDebitReportPage />
               </ProtectedRoute>
             } />
             <Route path="/invoices/hsn-report" element={
               <ProtectedRoute requiredPermissions={{ route: '/invoices', actions: ['view'] }}>
                 <HsnReportPage />
               </ProtectedRoute>
             } />
             <Route path="/invoices/credit-debit-notes" element={
               <ProtectedRoute requiredPermissions={{ route: '/invoices', actions: ['view'] }}>
                 <CreditDebitNoteListingPage />
               </ProtectedRoute>
             } />
             <Route path="/invoices/credit-debit-notes/new" element={
               <ProtectedRoute requiredPermissions={{ route: '/invoices', actions: ['create'] }}>
                 <CreditDebitNoteFormPage />
               </ProtectedRoute>
             } />
             <Route path="/invoices/credit-debit-notes/manual/new" element={
               <ProtectedRoute requiredPermissions={{ route: '/invoices', actions: ['create'] }}>
                 <ManualCreditDebitNoteFormPage />
               </ProtectedRoute>
             } />
             <Route path="/invoices/credit-debit-notes/:id/view" element={
               <ProtectedRoute requiredPermissions={{ route: '/invoices', actions: ['view'] }}>
                 <CreditDebitNoteViewPage />
               </ProtectedRoute>
             } />
             <Route path="/invoices/credit-debit-notes/:id/edit" element={
               <ProtectedRoute requiredPermissions={{ route: '/invoices', actions: ['edit'] }}>
                 <CreditDebitNoteFormPage />
               </ProtectedRoute>
             } />
            
            {/* Charge Master Routes */}
             <Route path="/charge-masters" element={
               <ProtectedRoute requiredPermissions={{ route: '/charge-masters', actions: ['view'] }}>
                 <ChargeMasterListingPage />
               </ProtectedRoute>
             } />
             
             {/* Reports Routes */}
             <Route path="/reports" element={
               <ProtectedRoute requiredPermissions={{ route: '/reports', actions: ['view'] }}>
                 <ReportsPage />
               </ProtectedRoute>
             } />
             <Route path="/reports/rm-inventory" element={
               <ProtectedRoute requiredPermissions={{ route: '/reports', actions: ['view'] }}>
                 <RMInventoryReportPage />
               </ProtectedRoute>
             } />
            <Route path="/reports/finished-goods-inventory" element={
              <ProtectedRoute requiredPermissions={{ route: '/reports', actions: ['view'] }}>
                <FinishedGoodsInventoryReportPage />
              </ProtectedRoute>
            } />
             <Route path="/reports/material-issue" element={
               <ProtectedRoute requiredPermissions={{ route: '/reports', actions: ['view'] }}>
                 <MaterialIssueReportPage />
               </ProtectedRoute>
             } />
             <Route path="/reports/supplier-performance" element={
               <ProtectedRoute requiredPermissions={{ route: '/reports', actions: ['view'] }}>
                 <SupplierPerformanceReportPage />
               </ProtectedRoute>
             } />
             <Route path="/reports/supplier-performance/details" element={
               <ProtectedRoute requiredPermissions={{ route: '/reports', actions: ['view'] }}>
                 <SupplierPerformanceDetailPage />
               </ProtectedRoute>
             } />
             <Route path="/reports/supplier-balance" element={
               <ProtectedRoute requiredPermissions={{ route: '/reports', actions: ['view'] }}>
                 <SupplierBalanceReportPage />
               </ProtectedRoute>
             } />
             <Route path="/reports/mis" element={
               <ProtectedRoute requiredPermissions={{ route: '/reports', actions: ['view'] }}>
                 <MISReportPage />
               </ProtectedRoute>
             } />
             <Route path="/reports/production" element={
               <ProtectedRoute requiredPermissions={{ route: '/reports', actions: ['view'] }}>
                 <ProductionReportPage />
               </ProtectedRoute>
             } />
<Route path="/reports/scrap" element={
              <ProtectedRoute requiredPermissions={{ route: '/reports', actions: ['view'] }}>
                <ScrapReportPage />
              </ProtectedRoute>
            } />
            <Route path="/reports/worker-performance" element={
              <ProtectedRoute requiredPermissions={{ route: '/reports', actions: ['view'] }}>
                <WorkerPerformancePage />
              </ProtectedRoute>
            } />
            <Route path="/reports/sales-order-performance" element={
               <ProtectedRoute requiredPermissions={{ route: '/reports', actions: ['view'] }}>
                 <SalesOrderPerformanceReportPage />
               </ProtectedRoute>
             } />
             <Route path="/reports/sales-order-performance/:salesOrderId" element={
               <ProtectedRoute requiredPermissions={{ route: '/reports', actions: ['view'] }}>
                 <SalesOrderPerformanceDetailPage />
               </ProtectedRoute>
             } />
           </Routes>
          <Toaster />
        </Router>
      </BranchProvider>
    </AuthProvider>
  );
}

export default App;